import { BaseService } from './base.service';

export interface ChatChannelTeam {
  id: number;
  name: string;
  color: string;
  badge_image: string | null;
}

export interface ChatChannel {
  id: string;
  name: string | null;
  type: string;
  created_by: string;
  created_at: string;
  metadata: Record<string, any> | null;
  members: ChatChannelMember[];
  last_message: ChatMessage | null;
  last_message_at: string | null;
  unread_count?: number;
  team?: ChatChannelTeam;
}

export interface ChatChannelMember {
  user_id: string;
  display_name: string | null;
  avatar_url: string | null;
  role: string;
  joined_at: string;
}

export interface ChatMessage {
  id: string;
  channel_id: string;
  user_id: string;
  content: string;
  created_at: string;
  user: { id: string; display_name: string; avatar_url: string | null } | null;
}

export interface UnreadCountEntry {
  count: number;
  team: { id: number; name: string } | null;
}

export interface UnreadCountsResponse {
  unread_counts: Record<string, UnreadCountEntry>;
  total: number;
}

export default class ChatService extends BaseService {
  public async getUserChannels() {
    return this.axios.get(`${this.backendUrl}/chat/channels`);
  }

  public async getChatSession(channelId: string) {
    return this.axios.get(`${this.backendUrl}/chat/channel/${channelId}/session`);
  }

  public async getUnreadCounts() {
    return this.axios.get<{ data: UnreadCountsResponse }>(`${this.backendUrl}/chat/unread-counts`);
  }

  public async getEmbedToken() {
    return this.axios.get(`${this.backendUrl}/chat/embed-token`);
  }
}
